import { defineMessages } from "react-intl";

import {
	foodAllergyMessages,
	medicineSensitivityMessages,
	otherAllergyMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/risks/allergiesAndSensitivities";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	allergiesAndSensitivities: {
		id: "ktx.form.allergies_and_sensitivities.title",
		defaultMessage: "Érzékenységek és Allergiák"
	},
	medicine: {
		id: "ktx.form.allergies_and_sensitivities.medicine",
		defaultMessage: "Gyógyszerérzékenység"
	},
	food: {
		id: "ktx.form.allergies_and_sensitivities.food",
		defaultMessage: "Ételallergia"
	},
	otherMedicine: {
		id: "ktx.form.allergies_and_sensitivities.medicine.other",
		defaultMessage: "Egyéb gyógyszerérzékenység"
	},
	otherFood: {
		id: "ktx.form.allergies_and_sensitivities.food.other",
		defaultMessage: "Egyéb ételallergia"
	},
	other: {
		id: "ktx.form.allergies_and_sensitivities.other",
		defaultMessage: "Egyéb allergia"
	}
});

const fields: { [key: string]: FieldData } = {
	medicineSensitivity: {
		type: "field",
		path: ["medicineSensitivity"],
		label: messages.medicine,
		errorMessages: genericErrorMessages,
		input: {
			type: "checkbox-group",
			props: {
				labels: medicineSensitivityMessages,
				direction: "vertical",
				columns: 2
			}
		}
	},
	medicineSensitivityOther: {
		type: "field",
		path: ["medicineSensitivityOther"],
		label: messages.otherMedicine,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	},
	foodAllergy: {
		type: "field",
		path: ["foodAllergy"],
		label: messages.food,
		errorMessages: genericErrorMessages,
		input: {
			type: "checkbox-group",
			props: {
				labels: foodAllergyMessages
			}
		}
	},
	foodAllergyOther: {
		type: "field",
		path: ["foodAllergyOther"],
		label: messages.otherFood,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	},
	otherAllergy: {
		type: "field",
		path: ["otherAllergy"],
		label: messages.other,
		errorMessages: genericErrorMessages,
		input: {
			type: "checkbox-group",
			props: {
				labels: otherAllergyMessages,
				columns: 2,
				direction: "vertical"
			}
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.medicineSensitivity }] },
		{ columns: [{ width: 12, field: fields.medicineSensitivityOther }] },
		{ columns: [{ width: 12, field: fields.foodAllergy }] },
		{ columns: [{ width: 12, field: fields.foodAllergyOther }] },
		{ columns: [{ width: 12, field: fields.otherAllergy }] }
	]
};

export const node: LeafNode = {
	id: "ktx_allergiesAndSensitivities",
	value: {
		schemaId: "allergiesAndSensitivities",
		title: messages.allergiesAndSensitivities,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
